export default function globalToast({ message }) {
    window.ifShow = true;
    if (window.ifShow) {
        const html = document.createElement('div')
        html.className = 'homePopUp'
        html.innerHTML = `<div class="bg"></div>><div class="centerText" style=>${message}</div>`
        document.getElementById('root').appendChild(html)
        window.ifShow = false
        setTimeout(() => {
            document.getElementById('root').removeChild(html)
        }, 3000)
    }

}



// WEBPACK FOOTER //
// ./common/lib/globalToast.js